<div class="container">
    <div *ngIf="creating" class="shortcut-panel alignRow alignColumn app-icon--goto">
        <button style="margin: auto;" mat-raised-button color="primary">
            <span>Dashboard</span>
            <mat-icon/>
        </button>
    </div>

    <div *ngIf="!creating && panelData" class="shortcut-panel alignRow alignColumn app-icon--goto">
        <button mat-raised-button color="primary" (click)="buttonClick(panelData.nodeData)">
            <span>{{panelData.nodeData.DashboardName}}</span>
            <mat-icon/>
        </button>
    </div>

    <div *ngIf="!creating && !panelData" class="spinner alignColumn">
        <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif">
    </div>
</div>